import { Component, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-c5-five-three-one',
  templateUrl: './c5-five-three-one.component.html',
  styleUrls: ['./c5-five-three-one.component.scss']
})
export class C5FiveThreeOneComponent implements OnInit {
  pdfSrc: string[] = [
    '/assets/pdf/NAAC/Criterion-5/5.3.1_Medals and awards_5 years_SSR_Final/5.3.1_2021-22_awards and medals_sports and cultural_FINAL.pdf', 
    '/assets/pdf/NAAC/Criterion-5/5.3.1_Medals and awards_5 years_SSR_Final/5.3.1_2020-21_awards and medals_sports and cultural_FINAL.pdf', 
    '/assets/pdf/NAAC/Criterion-5/5.3.1_Medals and awards_5 years_SSR_Final/5.3.1_2019-20_awards and medals_sports and cultural_FINAL.pdf', 
    '/assets/pdf/NAAC/Criterion-5/5.3.1_Medals and awards_5 years_SSR_Final/5.3.1_2018-19_awards and medals_sports and cultural_FINAL.pdf', 
    '/assets/pdf/NAAC/Criterion-5/5.3.1_Medals and awards_5 years_SSR_Final/5.3.1_2017-18_awards and medals_sports and cultural_FINAL.pdf', ];
  src: string;

  isLoading = true;
  constructor() { }

  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(year: string) {
    this.isLoading = true;
    if (year == '1') {
      $('.first').addClass('active');
      $('.second').removeClass('active');
      $('.third').removeClass('active');
      $('.fourth').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[0];
    }
    if (year == '2') {
      $('.second').addClass('active');
      $('.first').removeClass('active');
      $('.third').removeClass('active');
      $('.fourth').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[1];
    }
    if (year == '3') {
      $('.third').addClass('active');
      $('.first').removeClass('active');
      $('.second').removeClass('active');
      $('.fourth').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[2];
    }
    if (year == '4') {
      $('.fourth').addClass('active');
      $('.first').removeClass('active');
      $('.third').removeClass('active');
      $('.second').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[3];
    }
    if (year == '5') {
      $('.fifth').addClass('active');
      $('.first').removeClass('active');
      $('.third').removeClass('active');
      $('.second').removeClass('active');
      $('.fourth').removeClass('active');
      this.src = this.pdfSrc[4];
    }
    
    

  }
  hideLoader() {
    this.isLoading = false;
  }
}
